<template>
    <div>
        <Teleport  to="#teleports">
            <div class="modal fade" data-bs-backdrop="true" :id="`modal-${activeIndex}`" :key="`${activeIndex}_diamond_detail_attr_modal`" tabindex="-1" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content" >
                        <div class="modal-body ">
                            <div class="title_block">
                                <h5 class="mb-0 font-active">Diamond Properties</h5>
                                <span @click="hideModal">
                                    <SvgHeaderSvg type="close" class="largesvg"/>
                                </span>
                            </div>
                            <div class="setButtons">
                                <p @click="setActive(diamondParameters.color)"
                                    :class="{ active: activeTab === diamondParameters.color }" class="buttontype">
                                    Color</p>
                                <p @click="setActive(diamondParameters.carat)"
                                    :class="{ active: activeTab === diamondParameters.carat }" class="buttontype">
                                    Carat</p>
                                <p @click="setActive(diamondParameters.clarity)"
                                    :class="{ active: activeTab === diamondParameters.clarity }" class="buttontype">
                                    Clarity</p>
                                <p @click="setActive(diamondParameters.cut)"
                                    :class="{ active: activeTab === diamondParameters.cut }" class="buttontype" v-if="!(type === 'preset' || ['in-stock-ring', 'in-stock-earring', 'in-stock-pendant'].includes(dData.sub_type))">Cut
                                </p>
                            </div >
                            <div>
                                <div v-if="activeTab === diamondParameters.color">
                                <div class="title_block"> 
                                    <h3 class="mb-2 font-active" v-if="type === 'preset'">Color : <span class="caps">
                                          {{ dData.color.includes('-') ? dData.color : dData.color.split('').join('-') }}
                                        </span>
                                    </h3>
                                      
                                    <h3 class="mb-2 font-active" v-if="props.dData.sub_type === 'in-stock-ring'">Color : 
                                        <span class="caps">
                                          {{ dData.stone_one_color.includes('-') ? dData.stone_one_color : dData.stone_one_color.split('').join('-') }}
                                        </span>
                                    </h3>
                                    
                                        <h3 class="mb-2 font-active " v-if="!(type === 'preset' || ['in-stock-ring', 'in-stock-earring', 'in-stock-pendant'].includes(dData.sub_type))">Color : <span class="caps"> {{ dData.color_one || dData.color }} </span></h3>
                                    <!-- <span class="mb-2 font-active " v-else>Color : <span class="caps"> {{ dData.color || dData.color_one || dData.stone_one_color}} </span></span> -->
                                    <!-- <span class="mb-2 font-active" v-if="['in-stock-ring', 'in-stock-earring', 'in-stock-pendant'].includes(sub_type)">{{item.dData.sub_type}}</span> -->
                                </div>
                                <p class="title_mod">A diamond’s color grade measures the absence of color present in a diamond. Colorless diamonds let more light pass through than colored diamonds leading to more fire and sparkle.
    
                                 <br>Go for diamonds in the near colorless range (G-H-I) to get a beautiful diamond at a good price.
                                </p>
                                <div class="text-center" >
    
                                    <div class="images my-3" ref="scrollContainer">
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/m.svg">
                                            <p :class="{ 'highlight': isHighlighted('M') }">M</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/l.svg">
                                            <p :class="{ 'highlight': isHighlighted('L') }">L</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/k.svg">
                                            <p :class="{ 'highlight': isHighlighted('K') }">K</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/j.svg">
                                            <p :class="{ 'highlight': isHighlighted('J') }">J</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/i.svg">
                                            <p :class="{ 'highlight': isHighlighted('I') }">I</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/h.svg">
                                            <p :class="{ 'highlight': isHighlighted('H') }">H</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/g.svg">
                                            <p :class="{ 'highlight': isHighlighted('G') }">G</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/f.svg">
                                            <p :class="{ 'highlight': isHighlighted('F') }">F</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/e.svg">
                                            <p :class="{ 'highlight': isHighlighted('E') }">E</p>
                                        </div>
                                        <div class="box">
                                            <img width="115" height="72" src="/loose_graphics/color/d.svg">
                                            <p :class="{ 'highlight': isHighlighted('D') }">D</p>
                                        </div>
                                    </div>
                                </div>
                                    <div v-if="lowercase(dData.color || dData.color_one || dData.stone_one_color) === 'm'" class="text_mod">
                                    <p>A colored diamond with perfectly noticeable color to the naked eye.</p>
                                    </div>
                                    <div v-if="lowercase(dData.color || dData.color_one || dData.stone_one_color) === 'l'" class="text_mod">
                                    <p> A faint colored diamond with noticeable color to the naked eye. </p>
                                    </div>
                                    <div v-if="lowercase(dData.color || dData.color_one || dData.stone_one_color) === 'k'" class="text_mod">
                                    <p> A faint colored diamond with slightly noticeable color to the naked eye. </p>
                                    </div>
                                    <div v-if="lowercase(dData.color || dData.color_one || dData.stone_one_color) === 'j'" class="text_mod">
                                    <p> A nearly colorless diamond with detected color.</p>
                                    </div>
                                    <div v-if="lowercase(dData.color || dData.color_one || dData.stone_one_color) === 'i'" class="text_mod">
                                    <p> A good value, nearly colorless diamond with slightly detected color. </p>
                                    </div>
                                    <div v-if="lowercase(dData.color || dData.color_one || dData.stone_one_color) === 'h'" class="text_mod">
                                    <p> An excellent value, nearly colorless diamond with slightly detected color in comparison to better graded diamonds.</p>
                                    </div>
                                    <div v-if="lowercase(dData.color || dData.color_one || dData.stone_one_color) === 'g'" class="text_mod">
                                    <p> An excellent value, nearly colorless diamond with very slightly detected color in comparison to better graded diamonds. </p>
                                    </div>
                                    <div v-if="lowercase(dData.color || dData.color_one || dData.stone_one_color) === 'f'" class="text_mod">
                                    <p>A high quality colorless diamond with slightly detected color under magnification.</p>
                                    </div>
                                    <div v-if="lowercase(dData.color || dData.color_one || dData.stone_one_color) === 'e'" class="text_mod">
                                    <p>A rare, high quality colorless diamond with only minute color traces that are detected under magnification.</p>
                                    </div>
                                    <div v-if="lowercase(dData.color || dData.color_one || dData.stone_one_color) === 'd'" class="text_mod">
                                    <p>An extremely rare and highest quality diamond that is absolutely colorless and icy white.</p>
                                    </div>
                                </div>
                            </div>
                                <div v-if="activeTab === diamondParameters.carat">
                                    <div class="title_block">
                                        <h3 class="mb-2 font-active">
                                            Carat : 
                                            {{ (dData.weight || dData.stone_one_weight || dData.weight_one).includes('ct') 
                                              ? (dData.weight || dData.stone_one_weight || dData.weight_one) 
                                              : (dData.weight || dData.stone_one_weight || dData.weight_one) + ' ct' }}
                                          </h3>
                                    </div>
                                    <p class="title_mod">Carats are units used to measure your diamond's weight. 1-carat is equivalent to 200 milligrams or 0.2 grams. A diamond's size and carat weight are related; however, carats do not directly measure a diamond's size. With an increase in carat weight comes a price increase.
                                    The below illustration shows the relationship between typical diamond sizes and their increasing carat weights. Please note that while the measurements below are standard, every diamond is unique.                                
                                    <br>  
                                    </p>
                                    <!-- <div class="text-center my-2">
                                        <img width="130" height="100" :src="'/loose_setting/' + lowercase(dData.shape || dData.stone_one_shape || dData.shape_one) + '.svg'" alt="carat" />
                                    </div> -->
                                    <!-- <div class="title_mod">
                                        <p><b>Pro tip : </b>Choose a diamond below the carat cutoffs (Choose a 0.90 carat instead of a 1.00 carat diamond) to save money on your purchase while not losing too much on the size of the diamond.</p>
                                    </div> -->

                                    <div class="pictures" ref="scrollContainer">
                                        <div class="box text-center">
                                            <img width="304" height="304" src="/loose_graphics/carat/0.5ct.png" alt="Current Carat Image">
                                            <div class="ct">0.5ct</div>
                                            <div>(5.1mm)</div>
                                        </div>
                                        <div class="box text-center">
                                            <img width="304" height="304" src="/loose_graphics/carat/0.75ct.png" alt="Current Carat Image">
                                            <div class="ct">0.75ct</div>
                                            <div>(5.8mm)</div>
                                        </div>
                                        <div class="box text-center">
                                            <img width="304" height="304" src="/loose_graphics/carat/1ct.png" alt="Current Carat Image">
                                            <div class="ct">1ct</div>
                                            <div>(6.4mm)</div>
                                        </div>
                                        <div class="box text-center">
                                            <img width="304" height="304" src="/loose_graphics/carat/1.5ct.png" alt="Current Carat Image">
                                            <div class="ct">1.5ct</div>
                                            <div>(7.4mm)</div>
                                        </div>
                                        <div class="box text-center">
                                            <img width="304" height="304" src="/loose_graphics/carat/2ct.png" alt="Current Carat Image">
                                            <div class="ct">2ct</div>
                                            <div>(8.1mm)</div>
                                        </div>
                                        <div class="box text-center">
                                            <img width="304" height="304" src="/loose_graphics/carat/2.5ct.png" alt="Current Carat Image">
                                            <div class="ct">2.5ct</div>
                                            <div>(8.9mm)</div>
                                        </div>
                                        <div class="box text-center">
                                            <img width="304" height="304" src="/loose_graphics/carat/3ct.png" alt="Current Carat Image">
                                            <div class="ct">3ct</div>
                                            <div>(9.3mm)</div>
                                        </div>
                                        <div class="box text-center">
                                            <img width="304" height="304" src="/loose_graphics/carat/3.5ct.png" alt="Current Carat Image">
                                            <div class="ct">3.5ct</div>
                                            <div>(9.75mm)</div>
                                        </div>
                                        <div class="box text-center">
                                            <img width="304" height="304" src="/loose_graphics/carat/4ct.png" alt="Current Carat Image">
                                            <div class="ct">4ct</div>
                                            <div>(10.1mm)</div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                <div v-if="activeTab === diamondParameters.clarity">
                                    <div class="title_block"> 
                                        <h3 class="mb-2 font-active " v-if="type === 'preset'" >Clarity : <span class="caps"> {{ dData.clarity }} </span></h3>
                                        <h3 class="mb-2 font-active " v-else-if="dData.clarity && type !== 'preset'"> Clarity : <span class="caps">{{ dData.clarity }} </span></h3>
                                        <h3 class="mb-2 font-active " v-else>Clarity : <span class="caps"> {{ dData.stone_one_clarity || dData.clarity_one}} </span></h3>
                                    </div>
                                    <p class="title_mod">A diamond’s clarity measures the absence of impurities on and within a diamond.
                                        Impurities also known as flaws and inclusions occur during the diamond creation process. 
                                        The lesser the flaws and inclusions the higher its value.
                                    </p>
                                    <div class="text-center">
                                        <div class="images my-3" ref="scrollClarityContainer">
                                            <div class="box">
                                                <img width="115" height="72" src="/loose_graphics/clarity/si2.svg">
                                                <p :class="{ 'highlight': clairtyHighlighted('SI2') }">SI2</p>
                                            </div>
                                            <div class="box">
                                                <img width="115" height="72" src="/loose_graphics/clarity/si1.svg">
                                                <p :class="{ 'highlight': clairtyHighlighted('SI1') }">SI1</p>
                                            </div>
                                            <div class="box">
                                                <img width="115" height="72" src="/loose_graphics/clarity/vs2.svg">
                                                <p :class="{ 'highlight': clairtyHighlighted('VS2') }">VS2</p>
                                            </div>
                                            <div class="box">
                                                <img width="115" height="72" src="/loose_graphics/clarity/vs1.svg">
                                                <p :class="{ 'highlight': clairtyHighlighted('VS1') }">VS1</p>
                                            </div>
                                            <div class="box">
                                                <img width="115" height="72" src="/loose_graphics/clarity/vvs2.svg">
                                                <p :class="{ 'highlight': clairtyHighlighted('VVS2') }">VVS2</p>
                                            </div>
                                            <div class="box">
                                                <img width="115" height="72" src="/loose_graphics/clarity/vvs1.svg">
                                                <p :class="{ 'highlight': clairtyHighlighted('VVS1') }">VVS1</p>
                                            </div>
                                            <div class="box">
                                                <img width="115" height="72" src="/loose_graphics/clarity/if.svg">
                                                <p :class="{ 'highlight': clairtyHighlighted('IF') }">IF</p>
                                            </div>
                                            <div class="box">
                                                <img width="115" height="72" src="/loose_graphics/clarity/fl.svg">
                                                <p :class="{ 'highlight': clairtyHighlighted('FL') }">FL</p>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="text_mod" v-if="lowercase(dData.clarity || dData.clarity_one || dData.stone_one_clarity) === 'si2'">
                                        <p>A slightly included 2 (SI2) diamond has inclusions on and within the diamond that are visible under 10x magnification and might also be visible to the naked eye. SI2 diamonds have more inclusions than SI1 Diamonds.</p>
                                    </div>
                                    <div class="text_mod" v-if="lowercase(dData.clarity || dData.clarity_one || dData.stone_one_clarity) === 'si1'">
                                        <p>A slightly included 1 (SI1) diamond has inclusions that are visible under 10x magnification but might not be very visible to the naked eye.</p>
                                    </div>
                                    <div class="text_mod" v-if="lowercase(dData.clarity || dData.clarity_one || dData.stone_one_clarity) === 'vs2'">
                                        <p>A very slightly included 2 (VS2) diamond has inclusions that are hard to see under 10x magnification. The flaws & inclusions are mostly not visible to the naked eye and have slightly more inclusions than VS1 diamonds.</p>
                                    </div>
                                    <div class="text_mod" v-if="lowercase(dData.clarity || dData.clarity_one || dData.stone_one_clarity) === 'vs1'">
                                        <p>A very slightly included 1 (VS1) diamond has inclusions that are hard to see under 10x magnification. The flaws & inclusions are mostly not visible to the naked eye.</p>
                                    </div>
                                    <div class="text_mod" v-if="lowercase(dData.clarity || dData.clarity_one || dData.stone_one_clarity) === 'vvs2'">
                                        <p>A very very slightly included 2 (VVS2) diamond has inclusions that are very hard to see under 10x magnification and are not visible to the naked eye. They have slightly more inclusions than VVS1 diamonds.</p>
                                    </div>
                                    <div class="text_mod" v-if="lowercase(dData.clarity || dData.clarity_one || dData.stone_one_clarity) === 'vvs1'">
                                        <p>A very very slightly included 1 (VVS1) diamond has inclusions that are very hard to see under 10x magnification and are not visible to the naked eye.</p>
                                    </div>
                                    <div class="text_mod" v-if="lowercase(dData.clarity || dData.clarity_one|| dData.stone_one_clarity) === 'if'">
                                        <p>An Internally flawless (IF) diamond has almost no internal or external inclusions.</p>
                                    </div>
                                    <div class="text_mod" v-if="lowercase(dData.clarity || dData.clarity_one || dData.stone_one_clarity) === 'fl'">
                                        <p>A flawless diamond (FL) is an extremely rare and valuable diamond that has absolutely no internal and external inclusions or flaws.</p>
                                    </div>
                                </div>
                            </div>
                                <div v-if="!(type === 'preset' || ['in-stock-ring', 'in-stock-earring', 'in-stock-pendant'].includes(dData.sub_type))">
                                    <div v-if="activeTab === diamondParameters.cut">
                                        <div class="title_block">
                                            <h3 class="mb-2 font-active">Cut : {{dData.cut_grade || dData.cut_grade_one }}</h3>
                                        </div>
                                        <p class="title_mod">A diamond’s cut determines its beauty and is related to its depth, width, and facet uniformity. 
                                            A diamond’s ability to reflect and refract light is based on its cut.</p>
                                        <div class="text-center my-3">
                                            <div class="images my-3" ref="scrollCutContainer">
                                                <div class="box">
                                                    <img width="115" height src="/loose_graphics/newcut/fair.svg">
                                                    <p :class="{ 'highlight': cutHighlighted('Fair') }">Fair</p>
                                                </div>
                                                <div class="box">
                                                    <img width="115" height src="/loose_graphics/newcut/good.svg">
                                                    <p :class="{ 'highlight': cutHighlighted('Good') }">Good</p>
                                                </div>
                                                <div class="box">
                                                    <img width="115" height src="/loose_graphics/newcut/verygood.svg">
                                                    <p :class="{ 'highlight': cutHighlighted('Very Good') }">Very Good</p>
                                                </div>
                                                <div class="box">
                                                    <img width="115" height src="/loose_graphics/newcut/excellent.svg">
                                                    <p :class="{ 'highlight': cutHighlighted('Excellent') }">Excellent</p>
                                                </div>
                                                <div class="box">
                                                    <img width="115" height src="/loose_graphics/newcut/ideal.svg">
                                                    <p :class="{ 'highlight': cutHighlighted('Ideal') }">Ideal</p>
                                                </div>
    
                                            </div>
                                            <!-- <img width="130" height="100" :src="'/loose_graphics/newcut/' + lowercase(dData.cut_grade || dData.cut_grade_one) + '.svg'" alt="cut" /> -->
                                        </div>
                                        
                                        <div class="text_mod" v-if="lowercase(dData.cut_grade || dData.cut_grade_one) === 'fair'">
                                            <p>A diamond of good quality that reflects light while increasing weight. This cut, however, does not have the brilliance of a good cut as it is affected by light that leaks past the pavilion.</p>
                                        </div>
                                        <div class="text_mod" v-if="lowercase(dData.cut_grade || dData.cut_grade_one) === 'good'">
                                            <p>A diamond cut of superior quality to improve size without cutting on beauty and quality. A good cut reflects most of the light that enters the diamond.</p>
                                        </div>
                                        <div class="text_mod" v-if="lowercase(dData.cut_grade || dData.cut_grade_one) === 'excellent'">
                                            <p>A diamond cut of superior quality that reflects nearly as much light as an ideal cut diamond but at a cost that is significantly lower than an ideal cut diamond.</p>
                                        </div>
                                        <div class="text_mod" v-if="lowercase(dData.cut_grade || dData.cut_grade_one) === 'ideal'">
                                            <p>An exquisite cut that lends the diamond a great combination of fire and brilliance. An ideal diamond nearly reflects all the light that enters the diamond.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
        </Teleport>
    </div>
    
</template>
  
<script setup>

    // props definition 
    const props = defineProps({
        activeIndex: String,
        diamondParameters: Object,
        dData : Object,
        type : String
    });

    // Ref setups 
    const scrollContainer = ref('');
    const scrollClarityContainer = ref('');
    const scrollCutContainer = ref('');
    const startX = ref(0);
    const isDown = ref(false);
    const scrollLeft = ref(0);

    // active tab
    const activeIndex = ref(props.activeIndex);
    const activeTab = ref(''); 
    activeTab.value = props.activeIndex;

    // set active tab for watching tabs
    const setActive = (index) => {
        activeTab.value = index;

        nextTick(() => {
            if (activeTab.value === 'color') {
                handleScrollToHighlightedImage();
                clarityHorizontalScroll();
                initHorizontalScroll();
                initHorizontalCutScroll()
            }
            if (activeTab.value === 'clarity') {
                handleScrollclarity();
                scrollToclairtyImage();
                initHorizontalScroll();
                clarityHorizontalScroll()
                initHorizontalCutScroll()
                handleScrollToHighlightedImage();
            }
            if (activeTab.value === 'cut') {
                initHorizontalCutScroll()
                handleScrollToCut()
            }
            if (activeTab.value === 'carat') {
                initHorizontalScroll();
            }
        });
    };

    const emit = defineEmits(['close']);

    const hideModal = () => {
        emit('close');
        activeTab.value = null;
    };

    // utility functions
    const lowercase = (value) => {
        if (typeof value !== 'string') {
            return '';
        }
        return value.toLowerCase().replace(/[^\w]/gi, '');
    };

    const isHighlighted = (letter) => {
        let range = colorRange.value;
        if (typeof range === 'string') {
            if (range.includes('-')) {
                range = range.split('-');
            } else {
                range = range.split('');
            }
        } else if (!Array.isArray(range)) {
            range = [];
        }
        const upperRange = range.map(c => c.toUpperCase());
        return upperRange.includes(letter.toUpperCase());
    };

    // computed properties
    const colorRange = computed(() => {
        if (props.type === 'preset') {
            return props.dData.color || '';
        } else if (props.dData.sub_type === 'in-stock-ring') {
            return props.dData.stone_one_color || '';
        } else {
            return props.dData.color_one || props.dData.color || '';
        }
    });

    const clarityRange = computed(() => {
        if (props.type === 'preset') {
            return props.dData.clarity || props.dData.clarity_one || props.dData.stone_one_clarity ||  '';
            // props.dData.clarity || props.dData.clarity_one || props.dData.stone_one_clarity
        } else if (props.dData.sub_type === 'in-stock-ring') {
            return props.dData.clarity || props.dData.clarity_one || props.dData.stone_one_clarity || '';
        } else {
            return props.dData.clarity || props.dData.clarity_one || props.dData.stone_one_clarity || '';
        }
    });

    const cutRange = computed(()=>{
        //  "!(type === 'preset' || ['in-stock-ring', 'in-stock-earring', 'in-stock-pendant'].includes(dData.sub_type))">
        // and this is a common return dData.cut_grade || dData.cut_grade_one
        return props.dData.cut_grade || props.dData.cut_grade_one
    });
    // Highlighted function which checks which is active & not
    const clairtyHighlighted = (letter) => {
            let range = clarityRange.value;
            if(range === 'vs' && (letter==='VS1' || letter==='VS2')){
                return true; 
            }else{
                return range.toUpperCase() === letter.toUpperCase();
            }

    };

    const cutHighlighted = (letter)=>{
        let range = cutRange.value
        return range.toUpperCase() === letter.toUpperCase();
    }
    // scroll functions
    const scrollToclairtyImage = () => {
        const scroll_Container = scrollClarityContainer.value;
        if (scrollClarityContainer.value) {
            const highlightedElement = scroll_Container.querySelector('.highlight');
            if (highlightedElement) {
                highlightedElement.scrollIntoView({ behavior: 'smooth', block:'center', inline: 'center' });
            }
        }
    };

    const scrollToHighlightedImage = () => {
        const scroll_Container = scrollContainer.value;
        if (scrollContainer.value) {
            const highlightedElement = scroll_Container.querySelector('.highlight');
            if (highlightedElement) {
                highlightedElement.scrollIntoView({ behavior: 'smooth', inline: 'center' });
            }
        }
    };

    const scrollToCut = () => {
        const scroll_Container = scrollCutContainer.value;
        if (scrollCutContainer.value) {
            const highlightedElement = scroll_Container.querySelector('.highlight');
            if (highlightedElement) {
                highlightedElement.scrollIntoView({ behavior: 'smooth', inline: 'center' });
            }
        }
    };
    
    const handleScrollToCut = ()=>{
        scrollToCut();
    }

    const handleScrollToHighlightedImage = () => {
        scrollToHighlightedImage();
    };

    const handleScrollclarity = () => {
        scrollToHighlightedImage();
    };

    // preset slider 
    
    function initHorizontalCutScroll() {
    if (scrollCutContainer.value) {
        const scroll_Container = scrollCutContainer.value;

        scroll_Container.addEventListener('mousedown', (e) => {
            isDown.value = true;
            startX.value = e.pageX - scroll_Container.offsetLeft;
            scrollLeft.value = scroll_Container.scrollLeft;
           
        });

        scroll_Container.addEventListener('mouseleave', () => {
            isDown.value = false;
            scroll_Container.classList.remove('no-select'); // Remove class
        });

        scroll_Container.addEventListener('mouseup', () => {
            isDown.value = false;
            scroll_Container.classList.remove('no-select'); // Remove class
        });

        scroll_Container.addEventListener('mousemove', (e) => {
            if (!isDown.value) return;
            e.preventDefault();
            const x = e.pageX - scroll_Container.offsetLeft;
            const walk = (x - startX.value) * 2; // Adjust scrolling speed here
            scroll_Container.scrollLeft = scrollLeft.value - walk;
        });
    }
    }
    function initHorizontalScroll() {
    if (scrollContainer.value) {
        const scroll_Container = scrollContainer.value;

        scroll_Container.addEventListener('mousedown', (e) => {
            isDown.value = true;
            startX.value = e.pageX - scroll_Container.offsetLeft;
            scrollLeft.value = scroll_Container.scrollLeft;
           
        });

        scroll_Container.addEventListener('mouseleave', () => {
            isDown.value = false;
            scroll_Container.classList.remove('no-select'); // Remove class
        });

        scroll_Container.addEventListener('mouseup', () => {
            isDown.value = false;
            scroll_Container.classList.remove('no-select'); // Remove class
        });

        scroll_Container.addEventListener('mousemove', (e) => {
            if (!isDown.value) return;
            e.preventDefault();
            const x = e.pageX - scroll_Container.offsetLeft;
            const walk = (x - startX.value) * 2; // Adjust scrolling speed here
            scroll_Container.scrollLeft = scrollLeft.value - walk;
        });
    }
    }

    // function initHorizontalScroll() {
    //     if (scrollContainer.value) {
    //         const scroll_Container = scrollContainer.value;
    //         scroll_Container.addEventListener('mousedown', (e) => {
    //             isDown.value = true;
    //             startX.value = e.pageX - scroll_Container.offsetLeft;
    //             scrollLeft.value = scroll_Container.scrollLeft;
    //         });

    //         scroll_Container.addEventListener('mouseleave', () => {
    //             isDown.value = false;
    //         });

    //         scroll_Container.addEventListener('mouseup', () => {
    //             isDown.value = false;
    //         });

    //         scroll_Container.addEventListener('mousemove', (e) => {
    //             if (!isDown.value) return;
    //             e.preventDefault();
    //             const x = e.pageX - scroll_Container.offsetLeft;
    //             const walk = (x - startX.value) * 2; // Adjust scrolling speed here
    //             scroll_Container.scrollLeft = scrollLeft.value - walk;
    //         });
    //     }
    // }
    function clarityHorizontalScroll() {
        if (scrollClarityContainer.value) {
            const scroll_Container = scrollClarityContainer.value;
            scroll_Container.addEventListener('mousedown', (e) => {
                isDown.value = true;
                startX.value = e.pageX - scroll_Container.offsetLeft;
                scrollLeft.value = scroll_Container.scrollLeft;
                scroll_Container.classList.add('no-select');
            });

            scroll_Container.addEventListener('mouseleave', () => {
                isDown.value = false;
            });

            scroll_Container.addEventListener('mouseup', () => {
                isDown.value = false;
            });

            scroll_Container.addEventListener('mousemove', (e) => {
                if (!isDown.value) return;
                e.preventDefault();
                const x = e.pageX - scroll_Container.offsetLeft;
                const walk = (x - startX.value) * 2; // Adjust scrolling speed here
                scroll_Container.scrollLeft = scrollLeft.value - walk;
            });
        }
    }
  
    // lifecycle hooks
    onMounted(async () => {
        await nextTick();
        scrollToHighlightedImage();
        scrollToclairtyImage();
        handleScrollToHighlightedImage();
        initHorizontalScroll();
        initHorizontalCutScroll()
        handleScrollToCut()
        handleScrollclarity()
        clarityHorizontalScroll();
    });

    defineExpose({
        scrollToHighlightedImage,
        scrollToclairtyImage,
        handleScrollToHighlightedImage,
        initHorizontalCutScroll,
        handleScrollToCut
    });

</script>

  

<style scoped>
.pictures {
    display: flex;
    overflow-x: auto; 
    gap: 16px;
    align-items: center;
    cursor: pointer;
    padding-bottom: 10px;
    margin-top: 10px;
}

.pictures .box {
    flex: 0 0 auto; 
    width: 80px;
    user-select: none;
}

.box .ct {
    font-weight: 600;
}


.images {
    display: flex;
    overflow-x: auto; 
    gap: 16px;
    align-items: center;
    cursor: pointer;
}

.images .box {
    flex: 0 0 auto; 
    width: auto; 
    text-align: center;
}
.box p{
    margin-bottom: 6px;
}
.highlight {
    color: #668b84;
    font-weight: bold;
    text-decoration: underline;
  }

.largesvg {
    transform: scale(1.3);
    }
p {
    margin: 0;
    color: #606060;
}

.title_block {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.title_block span {
    cursor: pointer;
}

.title_block h3 {
    font-size: 22px;
    text-transform: capitalize;
}

.caps {
    text-transform: uppercase;
}

.active_tab {
    margin: 10px 0 0;
}

.setButtons {
    display: flex;
    align-items: center;
    margin: 16px 0 16px;
    justify-content: space-between;
    text-transform: uppercase;
    cursor: pointer;
    letter-spacing: 1px;
}

.setButtons .buttontype.active {
    border-color: var(--green);
    color: var(--green);
}

.buttontype {
    width: 25%;
    text-align: center;
    color: #606060;
    margin-right: 10px;
    padding: 5px 12px;
    border: 1px solid #606060;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 600;
}

/* -----scroll--------- */
/* width */
.pictures::-webkit-scrollbar {
    width: 5px;
    height: 3px;
  }
  
  /* Track */
  .pictures ::-webkit-scrollbar-track {
    background: #f5f5f5; 
  }
   
  /* Handle */
  .pictures::-webkit-scrollbar-thumb {
    background: #c4c4c4; 
    cursor: pointer;
  }
  
  /* Handle on hover */

  /* -----scroll--------- */

/* Responsive Styles */
@media (max-width: 768px) {
    .buttontype {
        border: 0;
        padding: 5px 0;
        text-align: left;
        /* border-radius: 0;
        border-right: 1px solid #606060;
        */
    }

    .title_block {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .title_block h5 {
        font-size: 24px;   
    }

    .title_block h3 {
        font-size: 20px;
        cursor: pointer;
    }

    .active_tab {
        margin: 10px 0 0;
    }
    .text_mod p ,.title_mod{
        margin: 10px 0;
        font-size: 14px;
    }

    .setButtons {
        display: flex;
        align-items: center;
        margin: 10px 0 10px;
        justify-content: space-between;
        text-transform: uppercase;
        cursor: pointer;
        letter-spacing: 1px;
    }

    .setButtons .buttontype.active {
        border-color: var(--green);
        color: var(--green);
        font-weight: 600;
        padding: 5px 5px;
    }

    .buttontype {
        width: 25%;
        text-align: center;
        color: #606060;
        margin-right: 10px;
        padding: 5px 12px;
        border: 1px solid #c4c4c4;
        border-radius: 4px;
        font-size: 14px;
        letter-spacing: 1.5px;
        font-weight: 400;
    }

    /* Responsive Styles */
    @media (max-width: 768px) {
        .buttontype {
            border: 1px solid #c4c4c4;
            padding: 5px 5px;
            /* text-align: left; */
        }
    }
}
/* -----scroll--------- */
/* width */
.images::-webkit-scrollbar {
    width: 5px;
    height: 3px;
  }
  
  /* Track */
  .images ::-webkit-scrollbar-track {
    background: #f5f5f5; 
  }
   
  /* Handle */
  .images::-webkit-scrollbar-thumb {
    background: #c4c4c4; 
    cursor: pointer;
  }
  
  /* Handle on hover */
</style>